export default __webpack_public_path__ + "static/media/Teacher.e3b0d33e.png";